<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
        ></go-lotus-side-menu>

        <div class="col-12 col-md-10 main-content position-relative">
            <div class="d-flex justify-content-between py-2">
                <a
                    v-if="component === 'therapist-overview'"
                    class="font-weight-bold text-uppercase link-primary"
                    href="/therapists"
                    ><i class="fa fa-angle-left mr-2"></i>Back to staff page</a
                >
                <a
                    v-else=""
                    class="font-weight-bold text-uppercase text-primary cursor-pointer"
                    @click="component = 'patient-overview'"
                    ><i class="fa fa-angle-left mr-2"></i>Back to {{ therapist.first_name }}'s
                    page</a
                >
                <a
                    class="btn btn-sm btn-primary text-uppercase font-weight-bold text-white"
                    :href="`/schedule?therapist_id=${therapist.id}`"
                    >View therapist's schedule</a
                >
            </div>
            <div class="row">
                <div class="col-12">
                    <component
                        :is="component"
                        :user="user"
                        :therapist="therapist"
                        :credentials="credentials"
                        :special-conditions="specialConditions"
                        :organization="organization"
                    ></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import TherapistOverview from "./therapist-details/TherapistOverview";
import { sideMenuItems } from "../plugins/sideMenuItems";

export default {
    name: "TherapistDetails",
    props: ["user", "organization", "therapist", "credentials", "specialConditions"],
    mixins: [sideMenuItems],
    components: {
        GoLotusSideMenu,
        TherapistOverview,
    },
    data() {
        return {
            patient: {},
            component: "therapist-overview",
        };
    },
    created() {},
    methods: {},
};
</script>

<style scoped lang="scss"></style>
